/* sb-dc-popupbackdrop.js — Pop-Up Display Backdrop as its own product in the
   design center. 2026-09-04.

   Three things the store asked for:

     1. Its own tab in CHOOSE PRODUCT, next to Step & Repeat. The 10'x8' banner
        was buried at the bottom of the Step & Repeat list and the 8'x8' was
        missing entirely, so half the range was unreachable from here.
     2. No finishing options. A tension-fabric backdrop is sewn into a sleeve
        that slips over the frame — hems, grommets and pole pockets do not
        apply to it, and offering them invites an order we cannot make.
     3. The frame as an add-on. It is a separate product in Shopify, so it goes
        on the order as its own line rather than a variant of the banner.

   All of this is done from outside the app bundle: the catalogue lives in a
   328 KB file the theme API will not take in one write, so the category is
   spliced into window.__CAT at runtime, the finishing column is replaced in
   the modal, and the stand is appended to the /cart/add.js request the same
   way sb-dc-cartprops.js edits its properties.

   Sizes and prices are the Shopify variants as of 2026-09-04:
     8'x8' banner only  115x91 or 112x91  $256   stand 8ft  $279
     10'x8' banner only 145x91 or 141x91  $320   stand 10ft $299
   The 88" height variants exist but are out of stock, so they are not offered.
   If any of that changes in Shopify it has to change here too. */
(function () {
  'use strict';

  var CAT_NAME = 'Pop-Up Display Backdrop';

  /* The frame that fits each banner. variantId is what /cart/add.js needs. */
  var STANDS = {
    '8x8-fabric-pop-up-display-backdrop-banner-only': {
      variantId: 50720902480167, price: 279, label: "8' x 8' Pop-Up Display Stand"
    },
    '10x8-fabric-pop-up-display-backdrop-banner-only': {
      variantId: 50720902512935, price: 299, label: "10' x 8' Pop-Up Display Stand"
    }
  };

  /* 2026-09-15 (store's request): one display name for both sizes, and the size is
     picked with 8'x8' / 10'x8' buttons in the Size panel (sizeSwitch below). They
     stay two catalogue products underneath, so cart variants, prices and the stand
     add-on are untouched; `name` (English, with the size) still goes on the order
     manifest. Only one of the two cards shows in CHOOSE PRODUCT (mergeCards). */
  var NAME = 'Pop-Up Display Backdrop (Banner Only)';
  var SIZES = [
    { handle: '8x8-fabric-pop-up-display-backdrop-banner-only', label: "8'x8'" },
    { handle: '10x8-fabric-pop-up-display-backdrop-banner-only', label: "10'x8'" }
  ];

  var EIGHT = {
    handle: '8x8-fabric-pop-up-display-backdrop-banner-only',
    name: "8'x8' Fabric Pop Up Display Backdrop (Banner Only)",
    nameKo: NAME,
    material: '270gsm fabric \u00b7 prints at 115\u2033 or 112\u2033 x 91\u2033 \u00b7 frame sold separately',
    materialEn: '270gsm Tension Fabric',
    unit: 'in', w: 115, h: 91, fixedOnly: true, viewFt: 8, qty: 1,
    minIn: 88, maxIn: 120,
    presetsIn: ['115x91', '112x91'],
    priceBySizeIn: { '115x91': 256, '112x91': 256 },
    optNames: { w: '(Width) Inches', h: '(Height) Inches' }
  };

  var state = { on: false };
  window.__dcPopupStand = state;

  function isOurs(handle) { return !!STANDS[String(handle || '')]; }
  function applied() {
    try { return (window.__dcAppliedProduct && window.__dcAppliedProduct()) || null; } catch (e) { return null; }
  }

  /* ---------- 1. the category ---------- */

  function installCategory() {
    var C = window.__CAT;
    if (!Array.isArray(C) || !C.length) return false;
    for (var i = 0; i < C.length; i++) if (C[i] && C[i].cat === CAT_NAME) return true;

    /* Move the 10'x8' out of Step & Repeat rather than copying it: two entries
       for one product would mean two ways to order the same thing. */
    var ten = null, at = 1;
    for (var c = 0; c < C.length; c++) {
      var items = (C[c] && C[c].items) || [];
      for (var k = 0; k < items.length; k++) {
        if (/pop-up-display-backdrop-banner-only$/.test(items[k].handle || '')) {
          ten = items[k]; items.splice(k, 1); at = c + 1; break;
        }
      }
      if (ten) break;
    }
    if (!ten) return false;   // catalogue not loaded the way we expect - leave it alone

    ten.nameKo = NAME;
    C.splice(at, 0, { cat: CAT_NAME, items: [EIGHT, ten] });
    return true;
  }

  /* ---------- 2 + 3. the modal: drop finishing, offer the stand ---------- */

  function css() {
    if (document.getElementById('sbdc-popup-css')) return;
    var st = document.createElement('style');
    st.id = 'sbdc-popup-css';
    st.textContent =
      '.sbdc-popup-addon{border:1px solid #cfd8de;border-radius:10px;padding:12px 14px;margin:0 0 14px;background:#f7fafb}' +
      '.sbdc-popup-addon label{display:flex;gap:10px;align-items:flex-start;cursor:pointer}' +
      '.sbdc-popup-addon input{margin-top:3px;width:16px;height:16px;flex:none}' +
      '.sbdc-popup-addon b{display:block;font-size:14px}' +
      '.sbdc-popup-addon small{display:block;color:#5b6672;line-height:1.45;margin-top:2px}' +
      '.sbdc-popup-addon .sbdc-popup-price{float:right;font-weight:700}' +
      '.sbdc-popup-note{color:#5b6672;font-size:13px;line-height:1.5;margin:0}';
    document.head.appendChild(st);
  }

  /* The finishing block is an h3 plus everything up to the next h3. */
  function finishingNodes(modal) {
    var out = [], h3s = modal.querySelectorAll('h3'), start = null;
    for (var i = 0; i < h3s.length; i++) {
      if (/finishing/i.test(h3s[i].textContent || '')) { start = h3s[i]; break; }
    }
    if (!start) return out;
    out.push(start);
    var n = start.nextElementSibling;
    while (n && n.tagName !== 'H3') { out.push(n); n = n.nextElementSibling; }
    return out;
  }

  function selectedHandle(modal) {
    /* While the modal is open the choice is the highlighted product, not the
       one currently applied to the canvas. */
    var on = modal.querySelector('.sbdc-prod.is-on');
    var h = on && on.getAttribute('data-handle');
    return isOurs(h) ? h : null;
  }

  /* One card for the two sizes: show the selected one, or 8'x8' when neither is.
     The other stays in the DOM (hidden) so nostart/tplfix/blank can still click it
     for a 10'x8' ?product= link. */
  function mergeCards() {
    var modal = document.getElementById('sbdc-start');
    if (!modal) return;
    var a = modal.querySelector('.sbdc-prod[data-handle="' + SIZES[0].handle + '"]');
    var b = modal.querySelector('.sbdc-prod[data-handle="' + SIZES[1].handle + '"]');
    if (!a || !b) return;
    var showB = b.classList.contains('is-on');
    a.style.display = showB ? 'none' : '';
    b.style.display = showB ? '' : 'none';
  }

  function paint() {
    var modal = document.querySelector('.sbdc-modal');
    if (!modal) return;
    var handle = selectedHandle(modal);
    var block = modal.querySelector('.sbdc-popup-addon');
    var nodes = finishingNodes(modal);

    if (!handle) {
      /* Not our product: put finishing back and take our block away. */
      nodes.forEach(function (n) { if (n.dataset.sbdcHidden) { n.style.display = ''; delete n.dataset.sbdcHidden; } });
      if (block) block.parentNode.removeChild(block);
      var gone = modal.querySelector('.sbdc-popup-note');
      if (gone) gone.parentNode.removeChild(gone);
      return;
    }

    nodes.forEach(function (n) { n.dataset.sbdcHidden = '1'; n.style.display = 'none'; });

    var stand = STANDS[handle];
    if (!block) {
      var host = nodes.length ? nodes[0].parentNode : null;
      if (!host) return;
      block = document.createElement('div');
      block.className = 'sbdc-popup-addon';
      block.innerHTML =
        '<label><input type="checkbox"><span><b>Add the Pop-Up Display Stand' +
        '<span class="sbdc-popup-price"></span></b>' +
        '<small>The collapsible frame the backdrop stretches over. Ships as a separate item ' +
        'on the same order. Leave it unticked if you already own the frame.</small></span></label>';
      var note = document.createElement('p');
      note.className = 'sbdc-popup-note';
      note.textContent = 'This backdrop needs no finishing \u2014 the fabric is sewn into a sleeve that slips over the frame.';
      host.insertBefore(block, nodes[0]);
      host.insertBefore(note, block.nextSibling);
      block.querySelector('input').addEventListener('change', function () {
        state.on = this.checked;
      });
    }
    block.querySelector('.sbdc-popup-price').textContent = '  +$' + stand.price;
    var box = block.querySelector('input');
    if (box.checked !== state.on) box.checked = state.on;
  }

  /* ---------- the size buttons in the Size panel ---------- */

  function catItem(handle) {
    var C = window.__CAT || [];
    for (var i = 0; i < C.length; i++) {
      var items = (C[i] && C[i].items) || [];
      for (var k = 0; k < items.length; k++) if (items[k] && items[k].handle === handle) return items[k];
    }
    return null;
  }

  /* Same route the layout panel's size picker uses (src/host.js): name the other
     product on the spec, then let the app re-read its product from the spec. The
     spec change is one undo step, and undo puts the product back the same way. */
  function switchTo(handle) {
    var api = window.__dcApi, p = applied(), it = catItem(handle);
    if (!api || !api.setSpec || !it || (p && p.handle === handle)) return;
    api.setSpec({ __dcProd: handle, widthIn: it.w, heightIn: it.h });
    setTimeout(function () {
      try { if (window.__dcSyncProductFromSpec && window.__dcSyncProductFromSpec()) api.setSpec({}, false); } catch (e) {}
    }, 0);
  }

  function sizeSwitch() {
    var body = document.querySelector('.flyout[aria-label="Size"] .flyout-body');
    var box = document.querySelector('.sbdc-popsize');
    var p = applied();
    if (!body || !p || !isOurs(p.handle)) { if (box) box.parentNode.removeChild(box); return; }
    if (!box || box.parentNode !== body) {
      if (box) box.parentNode.removeChild(box);
      var anchor = body.querySelector('.size-row');
      if (!anchor) return;
      box = document.createElement('div');
      box.className = 'chips sbdc-popsize';
      SIZES.forEach(function (s) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'chip';
        b.setAttribute('data-handle', s.handle);
        b.textContent = s.label;
        b.addEventListener('click', function () { switchTo(s.handle); });
        box.appendChild(b);
      });
      body.insertBefore(box, anchor);
    }
    var bs = box.querySelectorAll('button');
    for (var i = 0; i < bs.length; i++) {
      var on = bs[i].getAttribute('data-handle') === p.handle;
      if (bs[i].classList.contains('is-active') !== on) bs[i].classList.toggle('is-active', on);
    }
  }

  /* ---------- the cart ---------- */

  function standLine() {
    var p = applied();
    if (!p || !isOurs(p.handle) || !state.on) return null;
    var stand = STANDS[p.handle];
    var qty = 1;
    try { qty = Math.max(1, +(window.__dcApi && window.__dcApi.spec && window.__dcApi.spec.quantity) || 1); } catch (e) {}
    return {
      id: stand.variantId,
      quantity: qty,
      properties: { '_addon_for': 'Design Center', 'ADD-ON': stand.label }
    };
  }

  function isCartAdd(url) {
    try { return /\/cart\/add(\.js)?(\?|$)/.test(String(url || '')); } catch (e) { return false; }
  }

  function wrapFetch() {
    var orig = window.fetch;
    if (typeof orig !== 'function' || orig.__dcPopupWrapped) return;
    var wrapped = function (input, init) {
      try {
        var url = (typeof input === 'string') ? input : (input && input.url) || '';
        var body = init && init.body;
        if (isCartAdd(url) && typeof body === 'string') {
          var data = JSON.parse(body);
          var p = applied();
          if (p && isOurs(p.handle)) {
            /* Finishing never applies here, so make sure none reaches the
               order even if the app filled a default in. */
            var strip = function (it) {
              if (it && it.properties) {
                delete it.properties['FINISHING OPTIONS'];
                delete it.properties['Finishing'];
              }
            };
            if (Array.isArray(data.items)) data.items.forEach(strip); else strip(data);

            var line = standLine();
            if (line) {
              if (!Array.isArray(data.items)) data = { items: [data] };
              data.items.push(line);
            }
            init = Object.assign({}, init, { body: JSON.stringify(data) });
          }
        }
      } catch (e) {
        /* An add to cart must never fail because of this file. */
        try { console.warn('[design-center] pop-up add-on skipped:', e); } catch (e2) {}
      }
      return orig.apply(this, [input, init]);
    };
    wrapped.__dcPopupWrapped = true;
    window.fetch = wrapped;
  }

  /* ---------- boot ---------- */

  css();
  wrapFetch();

  var tries = 0;
  var boot = setInterval(function () {
    if (installCategory() || ++tries > 100) clearInterval(boot);
  }, 200);

  /* The modal is rebuilt every time it opens, so paint on a timer rather than
     hooking a button that may not exist yet. */
  setInterval(function () { try { paint(); } catch (e) {} try { mergeCards(); sizeSwitch(); } catch (e) {} }, 300);
  /* A fresh product means a fresh decision about the frame. */
  var lastHandle = null;
  setInterval(function () {
    var p = applied(), h = p && p.handle;
    if (h !== lastHandle) { lastHandle = h; if (!isOurs(h)) state.on = false; }
  }, 500);
})();
